import { createObjectKey } from './utils/create-object-key';
import { createSyncEvent } from './utils/create-sync-event';
import { BATCH_SIZE_SOFT_LIMIT, IDB_STORE_JOURNAL } from './constants';
import { TransactionalIndexedDBWriter } from './transactional-indexed-db-writer';
import type { SyncAnnotationData, SyncEvent, SyncEventType } from './types';
export class BufferedEventJournaler extends TransactionalIndexedDBWriter {
  private readonly buffer: Map<string, SyncEvent> = new Map();
  enqueue(type: SyncEventType, taskID: string, videoId: string, frameIndex: number, annotationId: string, annotation?: SyncAnnotationData): void {
    const event = createSyncEvent({
      taskID,
      videoId,
      type,
      frameIndex,
      annotationId,
      annotation
    });
    const objectKey = createObjectKey(taskID, videoId, frameIndex, annotationId);
    this.buffer.set(objectKey, event);
    if (this.buffer.size >= BATCH_SIZE_SOFT_LIMIT) {
      this.petitionForWrite();
    }
  }
  getStores(): readonly string[] {
    return ([IDB_STORE_JOURNAL] as const);
  }
  getBufferSize(): number {
    return this.buffer.size;
  }
  writeToIdb(tx: IDBTransaction, rollbackNotificationChannel: (notificationReceiver: () => void) => void): void {
    if (this.buffer.size === 0) return;
    const snapshot = new Map(this.buffer);
    this.buffer.clear();
    rollbackNotificationChannel(() => {
      for (const [objectKey, event] of snapshot) {
        if (!this.buffer.has(objectKey)) {
          this.buffer.set(objectKey, event);
        }
      }
    });
    const store = tx.objectStore(IDB_STORE_JOURNAL);
    for (const [objectKey, event] of snapshot) {
      store.put({
        objectKey,
        taskID: event.taskID,
        event
      });
    }
  }
}